import { Building, FileText, ShieldCheck } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/PageHeader";
import { InstallAppButton } from "@/components/InstallAppButton";
import { CompanyForm } from "@/pages/admin/settings/CompanyForm";
import { DocumentLanguagePanel } from "@/pages/admin/settings/DocumentLanguagePanel";
import { ChangePasswordForm } from "@/pages/admin/settings/ChangePasswordForm";
import { useI18n } from "@/i18n/I18nProvider";

const TABS = [
  { key: "company", icon: Building, Comp: CompanyForm },
  { key: "documents", icon: FileText, Comp: DocumentLanguagePanel },
  { key: "security", icon: ShieldCheck, Comp: ChangePasswordForm },
];

export default function Settings() {
  const { t } = useI18n();
  return (
    <div>
      <PageHeader title={t("settings.title")} subtitle={t("settings.subtitle")} testId="settings-title"
        action={<InstallAppButton testId="settings-install-app" className="sm:w-auto" />} />
      <Tabs defaultValue="company">
        <TabsList className="grid h-auto w-full grid-cols-3 bg-white p-1 shadow-sm sm:w-auto sm:inline-grid">
          {TABS.map(({ key, icon: Icon }) => (
            <TabsTrigger key={key} value={key} data-testid={`settings-tab-${key}`}
              className="flex min-h-[44px] gap-2 px-3 font-semibold data-[state=active]:bg-[#000B45] data-[state=active]:text-white sm:px-5">
              <Icon className="h-4 w-4 shrink-0" /> <span className="truncate">{t(`settings.${key}`)}</span>
            </TabsTrigger>
          ))}
        </TabsList>
        {TABS.map(({ key, Comp }) => (
          <TabsContent key={key} value={key} className="mt-6"><Comp /></TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
